import { Pagination } from 'antd'
import React from 'react'

const ANTDPagination = ({ ...props }) => {
  return <Pagination {...props} />
}

export default ANTDPagination
